import toast from "react-hot-toast";

export function showSuccess(message = "") {
  toast(message, { className: "bg-green-500 text-white" });
}

export function showError(message = "") {
  toast(message, { className: "bg-red-500 text-white" });
}
